







































import { Component, Prop, Vue } from 'vue-property-decorator';
import NetworkForm from './NetworkForm.vue';
import NetworkTemplates from './NetworkTemplates.vue';
import NetworkMerchants from './NetworkMerchants.vue';
import NetworkDomains from './NetworkDomains.vue';
import NetworkInstructions from './NetworkInstructions.vue';
import { Network } from '@/types';
import { APP_UPDATE_PAGE_TITLE } from '@/store/mutypes';

@Component({
  name: 'network-edit',
  components: {
    NetworkForm,
    NetworkTemplates,
    NetworkMerchants,
    NetworkDomains,
    NetworkInstructions
  }
})
export default class NetworkEdit extends Vue {
  @Prop({ required: true })
  private networkId!: number;
  private network: Network = {};
  private dataLoaded: boolean = false;

  onNetworkLoad(network: Network) {
    this.network = network;
    this.dataLoaded = true;
    this.$store.commit(
      APP_UPDATE_PAGE_TITLE,
      `Edit Network - ${network.network_name}`
    );
  }
}
